import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  signal,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { MessageService } from "../../infrastructure/message.service";

@Component({
  selector: "app-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent implements OnInit, OnDestroy {
  error = signal<string | null>(null);
  errorSubscription: Subscription | null = null;

  message = signal<string | null>(null);
  messageSubscription: Subscription | null = null;
  messageTimeout: number | null = null;

  constructor(
    private readonly messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit() {
    this.errorSubscription = this.messageService.error$.subscribe((item) => {
      this.markAsHandled(null);
      this.error.set(item);
    });

    // message is automatically hidden after a few seconds
    this.messageSubscription = this.messageService.message$.subscribe(
      (item) => {
        this.markAsHandled(null);

        if (this.messageTimeout) {
          window.clearTimeout(this.messageTimeout);
        }

        this.message.set(item);

        this.messageTimeout = window.setTimeout(
          () => {
            this.messageTimeout = null;
            this.message.set(null);
          },
          2000 + this.message.length * 100
        );
      }
    );

    // Clear error when user navigates to a different route
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.markAsHandled(null);
      });
  }

  ngOnDestroy() {
    this.errorSubscription?.unsubscribe();
    this.messageSubscription?.unsubscribe();
  }

  markAsHandled($event: Event | null) {
    this.error.set(null);
    if ($event !== null) {
      $event.preventDefault();
    }
  }
}
